export default __webpack_public_path__ + "static/media/mission.0a489c41.svg";